import { Trigger as TriggerPrimitive } from "@radix-ui/react-tooltip";
import styled from "styled-components";

export const Layout = styled(TriggerPrimitive)`
  overflow: hidden;
`;
